<template>
  <v-card
    tile
    minHeight="160"
    class="appointment-item"
    @click="onClickRedirect"
  >
    <v-list-item twoLine>
      <v-list-item-content>
        <v-list-item-title class="headline">
          <v-container>
            <v-row noGutters>
              <v-col
                cols="10"
                class="text-ellipsis"
              >
                {{ clientName }}
              </v-col>
              <v-col cols="2">
                <v-avatar
                  class="float-right"
                  color="secondary"
                  tile
                  size="36"
                >
                  <v-btn
                    tile
                    icon
                    size="24"
                    target="_blank"
                    :href="`http://maps.google.com/?q=${encodeURI(address)}`"
                  >
                    <v-icon>mdi-near-me</v-icon>
                  </v-btn>
                </v-avatar>
              </v-col>
            </v-row>
          </v-container>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ title }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        clientName: {
            type: String,
            required: true,
        },
        address: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
        clientId: {
            type: String,
            required: true,
        },
    },
    methods: {
        onClickRedirect() {
            this.$router.push({
                name: 'WorkOrderView',
                params: {
                    workOrderId: this.id,
                    clientId: this.clientId,
                    siteId: this.siteId,
                },
            });
        },
    },
};
</script>
